import {
  Switch,
  useComputedColorScheme,
  useMantineColorScheme,
} from '@mantine/core'
import { IconMoonStars, IconSun } from '@tabler/icons-react'
import Version from '../common/components/version/version'
import { Typography } from '../common/typography'
import { ReactComponent as LeaguestarIcon } from '../assets/leaguestar_icon.svg'
import { ReactComponent as LogoutIcon } from '../assets/logout-icon.svg'
import classes from './Navigation.module.css'
import { useLogout, User } from '../auth/api'
import { useNavigate } from 'react-router'
import { LeaguestarState } from '../state'
import { useQueryClient } from '@tanstack/react-query'

export default function NavigationFooter({
  isMobile,
  user,
}: {
  isMobile: boolean
  user: User
}) {
  const navigate = useNavigate()
  const { setColorScheme } = useMantineColorScheme()
  const computedColorScheme = useComputedColorScheme('light', {
    getInitialValueInEffect: true,
  })
  const { mutate: logout } = useLogout()
  const queryClient = useQueryClient()

  const handleLogout = () => {
    logout(undefined, {
      onSuccess: () => {
        navigate('/login')
      },
    })
  }

  const toggleTheme = (checked: boolean) => {
    setColorScheme(checked ? 'dark' : 'light')
  }

  const selectedPlatformId = LeaguestarState.useState(
    (s) => s.selected_platform_id
  )

  const currentPlatformName = user.platforms.find(
    (p) => p.platform_id === selectedPlatformId
  )?.platform_name

  const handleSwitchPlatform = () => {
    LeaguestarState.update((s) => {
      s.selected_platform_id = null
      s.competition_id = 0
    })
    localStorage.removeItem('leaguestar_selected_platform')
    queryClient.clear()
    navigate('/')
  }

  return (
    <div className={classes.navigationFooter} data-mobile={isMobile}>
      <div className={classes.footerRow}>
        <div className={classes.footerRowItemWrapper} onClick={handleLogout}>
          <LogoutIcon style={{ fill: '#ADB5BD' }} />
          <Typography fs="sm">Log out</Typography>
        </div>
        {user.platforms.length > 1 && currentPlatformName && (
          <span style={{ cursor: 'pointer' }} onClick={handleSwitchPlatform}>
            <Typography
              fs="xs"
              fc={{ light: 'primary-5', dark: 'primary-4' }}
              underline
            >
              {currentPlatformName} ›
            </Typography>
          </span>
        )}
      </div>
      <div className={classes.footerRow}>
        <div className={classes.footerRowItemWrapper}>
          <LeaguestarIcon width={25} height={25} style={{ fill: '#ADB5BD' }} />
          <Version component="navigation" />
        </div>
        <Switch
          checked={computedColorScheme === 'dark'}
          size="md"
          onChange={(event) => toggleTheme(event.currentTarget.checked)}
          onLabel={<IconSun size={18} stroke={2.5} color="#FFD43B" />}
          offLabel={<IconMoonStars size={18} stroke={2.5} />}
          withThumbIndicator={false}
          classNames={{
            track: classes.track,
            thumb: classes.thumb,
          }}
        />
      </div>
    </div>
  )
}
